import React, { useCallback, useEffect, useState } from "react";
import classes from "./Tab.module.css";
import TabHeader from "./TabHeader";
import images from "../../assets/images";
import { getTabBadgeColor } from "../../utils/constant";
import { getComponent } from "./tabUtils";
import TabPanel from "./TabPanel";
import { isEmpty } from "../../utils/utils";
import CommonModal from "../../common/modal/CommonModal";
const Tab = (props) => {
  const {
    tabs,
    focusTabIndex,
    goToNextTab,
    goToPrevTab,
    closeCurrentTab,
    variant,
    showCloseIcon = true,
    titleBarStartItems = null,
    enableTabSummary = false,
    titleBarEndItems = null,
    hiddenTabIndices = [],
    closeTab = () => {},
    tabClicked = () => {},
    updatedTabs = () => {},
    closeTriggered = () => {},
  } = props;
  const [tabList, setTabList] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentComponent, setCurrentComponent] = useState(null);
  const [componentParams, setComponentParams] = useState(null);
  const [updateTab, setUpdateTab] = useState(false);
  const [updateTabIndex, setUpdateTabIndex] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [showWarning, setShowWarning] = useState(null);
  const { kebabMenu, close } = images;
  const loadComponent = useCallback(() => {
    setShowWarning(null);
    if (currentIndex !== null && tabList && tabList.length > 0) {
      setCurrentComponent(() => {
        return getComponent(tabList[currentIndex].type);
      });
      !isEmpty(tabList[currentIndex].props)
        ? setComponentParams(tabList[currentIndex].props)
        : setComponentParams(null);
    }
  }, [currentIndex, tabList]);
  const tabClickHandler = useCallback(
    (index) => {
      if (currentIndex !== index) setCurrentComponent(null);
      setCurrentIndex(index);
      tabClicked(index);
    },
    [currentIndex, tabClicked]
  );
  const closeHandler = useCallback(
    (index) => {
      setShowWarning(null);
      closeTriggered({ triggered: false });
      let newIndex = currentIndex;
      if (currentIndex === index) {
        setCurrentComponent(null);
        if (index === tabList.length - 1) {
          newIndex = index - 1;
        } else if (index === 0) {
          newIndex = 0;
        }
      } else if (currentIndex > index) {
        newIndex = currentIndex - 1;
      }
      if (newIndex === -1) {
        newIndex = 0;
      }
      let updated_tabs = tabList.slice();
      let deleted_tab = updated_tabs[index];
      updated_tabs.splice(index, 1);
      setTabList(updated_tabs);
      setCurrentIndex(newIndex);
      closeTab(updated_tabs, newIndex, deleted_tab);
    },
    [closeTab, closeTriggered, currentIndex, tabList]
  );
  const updateTabList = useCallback((tabs) => {
    setCurrentComponent(null);
    setTabList(tabs);
    setUpdateTab(true);
  }, []);
  const clickListener = (e) => {
    setShowSummary(false);
  };
  const okHandler = useCallback(() => {
    closeHandler(showWarning?.index);
  }, [closeHandler, showWarning]);
  const cancelHandler = useCallback(() => {
    setShowWarning(null);
    closeTriggered({ triggered: false });
  }, [closeTriggered]);
  useEffect(() => {
    setCurrentComponent(null);
    setCurrentIndex(focusTabIndex);
    setUpdateTabIndex(true);
  }, [focusTabIndex]);
  useEffect(() => {
    if (updateTabIndex) {
      updatedTabs(null, focusTabIndex);
      setUpdateTabIndex(false);
    }
  }, [focusTabIndex, updateTabIndex, updatedTabs]);
  useEffect(() => {
    if (updateTab) {
      updatedTabs(tabs, currentIndex); //updated by alston
      setUpdateTab(false);
    }
  }, [currentIndex, tabs, updateTab, updatedTabs]);
  useEffect(() => {
    updateTabList(tabs);
  }, [updateTabList, tabs]);
  useEffect(() => {
    if (goToNextTab && currentIndex !== tabList?.length - 1) {
      setCurrentComponent(null);
      tabClickHandler(currentIndex + 1);
    }
  }, [currentIndex, goToNextTab, tabClickHandler, tabList?.length]);

  useEffect(() => {
    if (goToPrevTab && currentIndex !== 0) {
      setCurrentComponent(null);
      tabClickHandler(currentIndex - 1);
    }
  }, [currentIndex, goToPrevTab, tabClickHandler]);
  useEffect(() => {
    if (closeCurrentTab) {
      setShowWarning({ index: currentIndex });
      closeTriggered({ triggered: true });
    }
  }, [closeCurrentTab, currentIndex, closeTriggered]);
  useEffect(() => {
    loadComponent();
  }, [loadComponent]);
  useEffect(() => {
    if (showSummary) {
      window.addEventListener("click", clickListener, false);
    }
    return () => {
      window.removeEventListener("click", clickListener, false);
    };
  }, [showSummary]);
  return (
    <div className={classes["tab"]}>
      <div className={classes["header-container"]}>
        <div className={classes["title-bar-start"]}>
          {titleBarStartItems && titleBarStartItems.map((item) => item)}
          {tabList &&
            tabList.map((t, index) => {
              return (
                <TabHeader
                  isHidden={hiddenTabIndices.slice().indexOf(index) !== -1}
                  showCloseIcon={showCloseIcon}
                  startAvatar={t.startAvatar || null}
                  endAvatar={t.endAvatar || null}
                  label={t.label || t.type}
                  badgeStyle={getTabBadgeColor(index % 4)}
                  isActive={currentIndex === index}
                  variant={variant}
                  showTabSeperator={index !== currentIndex - 1}
                  key={`${t.label || t.type}_${index}`}
                  onClick={() => {
                    tabClickHandler(index);
                  }}
                  closeTab={() => {
                    setShowWarning({ index });
                    closeTriggered({ triggered: true });
                  }}
                />
              );
            })}
        </div>
        <div className={classes["title-bar-end"]}>
          {enableTabSummary && (
            <div
              className={classes["tabs-summary"]}
              onClick={(e) => {
                e.stopPropagation();
                setShowSummary((prev) => !prev);
              }}
            >
              <img src={kebabMenu} alt="menu" />
              <div
                className={`${classes["summary"]} ${
                  showSummary ? classes["visible"] : classes["hidden"]
                }`}
              >
                <ul>
                  {tabList?.map((t, index) => {
                    return (
                      <li
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          tabClickHandler(index);
                        }}
                      >
                        <div className={classes["summary-li"]}>
                          <div className={classes["summary-label-container"]}>
                            {(t.label || t.type) && (
                              <div
                                style={{ ...getTabBadgeColor(index % 4) }}
                                className={classes["summary-start-avatar"]}
                              >
                                {(t.label || t.type)
                                  ?.split(" ")
                                  .map((l) => l.slice(0, 1))
                                  .join("")}
                              </div>
                            )}
                            <div>{t.label || t.type}</div>
                          </div>
                          <div
                            className={classes["summary-close"]}
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowWarning({ index });
                              closeTriggered({ triggered: true });
                            }}
                          >
                            <img
                              src={close}
                              alt="close"
                              width="15px"
                              height="15px"
                            />
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
          {titleBarEndItems && (
            <div className={classes["title-bar-end-icons"]}>
              {titleBarEndItems.map((item) => item)}
            </div>
          )}
        </div>
        {variant !== "filled" && <div className={classes["track"]} />}
      </div>
      {currentComponent && (
        <div className={classes["panel"]}>
          <TabPanel
            key={tabList?.[currentIndex]?.type || currentIndex}
            component={currentComponent}
            componentParams={componentParams}
          />
        </div>
      )}
      {!isEmpty(showWarning) && (
        <CommonModal
          type="error"
          title="You will lose any unsaved changes. Do you wish to proceed?"
          okButtonText="Discard"
          cancelButtonText="Stay here"
          onOk={okHandler}
          onCancel={cancelHandler}
          onEscape={cancelHandler}
          onClose={cancelHandler}
        />
      )}
    </div>
  );
};

export default Tab;
